/** Side length of a plot in pixels. */
export const PLOT_SIZE = 64
/** Number of palette indices in a plot buffer. */
export const BUFFER_LENGTH = PLOT_SIZE * PLOT_SIZE
/** Maximum counted tokens per plot (see tokens.ts for the rules). */
export const TOKEN_BUDGET = 1024
/** Hard cap on source length in characters, comments included. */
export const CHAR_CAP = 12000
/** String literals cost one token per this many characters. */
export const STRING_CHARS_PER_TOKEN = 16
/** Plots animate at this many frames per second. */
export const PLOT_FPS = 15
/** CPU budget for a single draw() call. */
export const FRAME_BUDGET_MS = 2
/** Consecutive over-budget frames before a plot overheats. */
export const OVERHEAT_FRAMES = 3
